
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Carlos Mendoza',
      role: 'Propietario de Finca',
      image: 'https://public.readdy.ai/ai/img_res/26a24d8ddc4590725607f7162d595e98.jpg',
      rating: 5,
      text: 'Excelente servicio, ahora tenemos agua todo el año. El equipo fue muy profesional.',
      project: 'Pozo agrícola - 80m'
    },
    {
      name: 'María Fernández',
      role: 'Administradora',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latina%20businesswoman%20portrait%2C%20confident%20smile%2C%20office%20setting%2C%20simple%20clean%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=test-002&orientation=squarish',
      rating: 5,
      text: 'Trabajo rápido y profesional. Resolvieron el problema de abastecimiento de agua.',
      project: 'Sistema residencial'
    },
    {
      name: 'Roberto Silva',
      role: 'Ingeniero Agrónomo',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latino%20engineer%20man%20portrait%2C%20confident%20smile%2C%20outdoor%20field%20setting%2C%20simple%20clean%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=test-003&orientation=squarish',
      rating: 5,
      text: 'Muy recomendados para proyectos agrícolas. El estudio geofísico fue clave.',
      project: 'Estudio y perforación - 120m'
    },
    {
      name: 'Ana Gutiérrez',
      role: 'Propietaria',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latina%20woman%20homeowner%20portrait%2C%20warm%20smile%2C%20home%20setting%2C%20simple%20clean%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=test-004&orientation=squarish',
      rating: 5,
      text: 'Finalmente tenemos agua propia en casa. El servicio fue impecable.',
      project: 'Pozo residencial'
    },
    {
      name: 'Luis Ramírez',
      role: 'Gerente Industrial',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latino%20businessman%20manager%20portrait%2C%20confident%20expression%2C%20industrial%20setting%2C%20simple%20clean%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=test-005&orientation=squarish',
      rating: 5,
      text: 'Solución perfecta para nuestra planta. Ha reducido nuestros costos operativos.',
      project: 'Sistema industrial - 150m'
    },
    {
      name: 'Patricia Torres',
      role: 'Dueña de Restaurante',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latina%20restaurant%20owner%20portrait%2C%20friendly%20smile%2C%20restaurant%20setting%2C%20simple%20clean%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=test-006&orientation=squarish',
      rating: 5,
      text: 'Servicio de primera calidad. Ahora tenemos agua abundante y de excelente calidad.',
      project: 'Pozo comercial'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-2 sm:mb-4">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            La satisfacción de nuestros clientes es nuestro mejor respaldo
          </p>
        </div>

        {/* Mobile: Horizontal scroll */}
        <div className="sm:hidden overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          <div className="flex gap-3" style={{ width: 'max-content' }}>
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white p-4 rounded-xl shadow-lg border border-gray-100 w-72 flex-shrink-0"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <img 
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">{testimonial.name}</h4>
                    <p className="text-xs text-gray-600">{testimonial.role}</p>
                  </div>
                </div>

                <div className="flex gap-0.5 mb-2">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>

                <p className="text-xs text-gray-700 leading-relaxed mb-3 italic">
                  "{testimonial.text}"
                </p>

                <div className="pt-2 border-t border-gray-100">
                  <p className="text-xs text-blue-600 font-semibold">
                    <i className="ri-checkbox-circle-line mr-1"></i>
                    {testimonial.project}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop: Grid */}
        <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-5 lg:p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm lg:text-base">{testimonial.name}</h4>
                  <p className="text-xs lg:text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base lg:text-lg"></i>
                ))}
              </div>

              <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-3 italic">
                "{testimonial.text}"
              </p>

              <div className="pt-3 border-t border-gray-100">
                <p className="text-xs lg:text-sm text-blue-600 font-semibold">
                  <i className="ri-checkbox-circle-line mr-1"></i>
                  {testimonial.project}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
